export default function (state, getters, rootState, rootGetters) {
    let rgs = rootState.dictionary;
    return rgs.paymentOperation.load
        || rgs.cash.load
        || rgs.currency.load
        || rgs.paymentAccount.load
        || rgs.paymentCategory.load
        || rgs.paymentDirection.load
        || rgs.paymentType.load
        || rgs.rateArticle.load;
}